// src/App.jsx
import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

// Import do JS do Bootstrap para Accordion/Collapse etc.
// (Se necessário, dependendo dos componentes que você usa)
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

// Componentes
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTopButton from "./components/ScrollToTopButton";

// Páginas
import Tutorial from "./pages/Tutorial"; // <-- Passa a ser a página principal
import Downloads from "./pages/Downloads"; // Opcional
import Faq from "./pages/Faq"; // Opcional

function App() {
  const [darkMode] = useState(false);

  // A cada mudança de darkMode, ajusta a classe do body
  useEffect(() => {
    document.body.className = darkMode
      ? "bg-dark text-light"
      : "bg-light text-dark";
  }, [darkMode]);

  return (
    <Router>
      <div className={`App ${darkMode ? "dark-mode" : "light-mode"}`}>
        {/* Navbar e Botão de Dark Mode */}
        <Navbar darkMode={darkMode} />

        {/* Definição de Rotas */}
        <Routes>
          {/*
            Rota principal "/" -> carrega diretamente o componente Tutorial.
            Ou seja, não há mais 'Home', o Tutorial será a página inicial.
          */}
          <Route path="/" element={<Tutorial />} />

          {/* Rotas opcionais */}
          <Route path="/downloads" element={<Downloads />} />
          <Route path="/faq" element={<Faq />} />

          {/* Caso usuário vá para alguma rota inexistente, redireciona para "/" */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>

        {/* Botão de voltar ao topo e Footer */}
        <ScrollToTopButton />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
